import gql from "graphql-tag";

const gqlQuery = gql`
  query user($username: ID) {
    user(username: $username) {
      id
      partnerId
      ownedByPartnerId
      username
      name
      email
      telephone
      customerIds
      serviceContractsFilter
      roles {
        id
        name
      }
    }
  }
`;

export default username => ({
  query: gqlQuery,
  skip: !username,
  variables: { username },
});
